module.exports = __webpack_public_path__ + "static/assets/bca50c870171c8264640c71f3e2846f2.svg";